import React, { Component } from 'react';
import * as func from "../../../../../../utils/functions";
import {MESSAGE, EDIT_MODE} from "../../../../../../wpconfig"

class Item extends Component {
  constructor(props) {
    super(props);

		const r = func.deepClone(this.props.record);

		this.state = {
			isEdit: r.is_edit ? EDIT_MODE.SHOW_EDIT : EDIT_MODE.SHOW,
			record : r,
		}
  }

	onEditSave = (event) => {
		event.preventDefault()

		let isEdit = '';
		if (this.state.isEdit === EDIT_MODE.SHOW) {
			isEdit = EDIT_MODE.SHOW_EDIT;
		} else if (this.state.isEdit === EDIT_MODE.SHOW_EDIT) {
			isEdit = EDIT_MODE.SAVE_EDIT;
		}

    const { record } = this.props

		if (isEdit === EDIT_MODE.SAVE_EDIT) {
			if (record.scholar_id) {
				func.updateData("admin/scholar/"+func.getParams("record_id")+"/meta/update", record).then((response) => {
					if (response.code === 'ok') {
						isEdit = EDIT_MODE.SHOW;
						this.setState({
							'isEdit': isEdit,
							record : func.deepClone(record)
						})
						this.props.showMessage('수정 되었습니다.');
					} else {
						this.props.showMessage('수정 실패 : ' + response.message)
						isEdit = EDIT_MODE.SHOW_EDIT;
					}
				});
			} else {
				if (this.meta_type.value === '') {
					this.meta_type.focus();
          this.props.showMessage('메타 타입을 선택해주세요.');
        } else {
          // ref 값으로 record 업데이트 - 초기값 설정
          record.meta_type = this.meta_type.value;

          delete record.is_edit;
          // console.log(record)
					func.updateData("admin/scholar/"+func.getParams("record_id")+"/meta/insert", record).then((response) => {
						if (response.code === 'ok') {
							this.setState({'isEdit': EDIT_MODE.SHOW});
							record[this.props.pkKey] = response[this.props.pkKey];
							this.props.onUpdate(this.props.arrIndex, record, true);
							this.props.showMessage('추가 되었습니다.');
						} else {
							this.props.showMessage('저장 실패 : ' + response.message);
              // isEdit = EDIT_MODE.SHOW_EDIT;
						}
					});
				}
			}
		} else {
			this.props.onEditIndex(this.props.index)
			this.setState({'isEdit': EDIT_MODE.SHOW_EDIT});
		}
	}

	onCloseDelete = (event) => {
		event.preventDefault()
		if (this.props.record.scholar_id) {
			if (this.state.isEdit) {
				Object.keys(this.state.record).map((key) => {
					if(this[key]) {
						this[key].value = this.state.record[key]
					}
				});
				this.props.onUpdate(this.props.arrIndex, this.state.record, true);
				this.setState({'isEdit': EDIT_MODE.SHOW});
			} else {
				if (confirm('메타정보 : ' + this.props.record.meta_type + '(' + this.props.record.meta_key + ')을(를) ' + MESSAGE.DELETE)) {
					func.updateData("admin/scholar/"+func.getParams("record_id")+"/meta/delete", this.props.record).then((response) => {
						if (response.code === 'ok') {
							this.props.showMessage('삭제 되었습니다.');
							this.props.onRemove(this.props.arrIndex)
						} else {
							this.props.showMessage('삭제 실패 : ' + response.message)
						}
					});
				}
			}
		} else {
			this.setState({'isEdit': EDIT_MODE.SHOW});
			this.props.onRemove(this.props.index)
		}
	}

	onClose = (e) => {
		this.setState({'isEdit': EDIT_MODE.SHOW});
		if (this.props.record[this.props.pkKey]) {78
			this.props.onUpdate(this.props.arrIndex, this.state.record);
		} else {
			this.props.onRemove(this.props.arrIndex)
		}
	}

	textEvent = (event) => {
		let record = this.props.record;
		record[event.target.name] = event.target.value;
		this.props.onUpdate(this.props.arrIndex, this.props.record, false);
	}


  render() {
    const { textEvent } = this
    const { record } = this.props
    // console.log(record)

    return (
      <>
        {
          this.state.isEdit === EDIT_MODE.SHOW ?
          <tr className="list-row">
            <td><label className="mt-2">{ this.props.meta_type_Names[record.meta_type] }</label></td>
			      <td><label className="mt-2">{ record.meta_key }</label></td>
            <td><label className="mt-2">{ record.meta_a }</label></td>
						<td>
							{record.meta_b &&
								<div>
									<label className="mt-2">{ record.meta_b }</label>
								</div>
							}
							{record.meta_b && record.meta_json &&
								<hr className="m-0 p-0"></hr>
							}
							{ record.meta_json &&
								<div>
									<label className="mt-2">{ record.meta_json }</label>
								</div>
							}
						</td>
            <td className="column-action">
              <div className="btn-group">
                <button className="btn btn-outline-success btn-sm insert"
                    onClick={this.onEditSave}>{record[this.props.pkKey] ? '수정' : '저장'}</button>
                <button className="btn btn-outline-danger btn-sm cancel" onClick={this.onCloseDelete}>삭제</button>
              </div>
            </td>
          </tr> 
          :
          <tr className="list-row">
            <td>
              <select className="form-control form-control-sm"
                defaultValue={record.meta_type}
                ref={(ref)=>this.meta_type=ref}
                name="meta_type"
                onChange={textEvent}>
                  {this.props.meta_types.map((type, i) => {
                    return (<option key={type.code_id} value={type.code_id}>{type.code_name}</option>)
                  })}
              </select>
            </td>
	          <td>
		          <input
			          type="text"
			          name="meta_key"
			          className="form-control"
			          ref={(ref)=>this.meta_key=ref}
			          value={record.meta_key || ""}
			          onChange={textEvent}
		          />
	          </td>
            <td>
              <input
                type="text"
                name="meta_a"
                className="form-control"
                ref={(ref)=>this.meta_a=ref}
                value={record.meta_a || ""}
                onChange={textEvent}
              />
            </td>
						<td>
							<input
								type="text"
								name="meta_b"
								className="form-control"
								ref={(ref)=>this.meta_b=ref}
								value={record.meta_b || ""}
								onChange={textEvent}
							/>
							<textarea
								name="meta_json"
								className="form-control"
								ref={(ref)=>this.meta_json=ref}
								value={record.meta_json || ""}
								onChange={textEvent}
								rows="1"
							/>
						</td>
            <td className="column-action">
              <div className="btn-group">
                <button className="btn btn-outline-primary btn-sm insert" onClick={this.onEditSave}>저장</button>
                <button className="btn btn-outline-secondary btn-sm cancel" onClick={this.onCloseDelete}>닫기</button>
              </div>
            </td>
          </tr>
        }
      </>
    )
  }
}

export default Item;